var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00005 3.28573C2.97438 3.28573 2.14291 4.1172 2.14291 5.14287C2.14291 5.37957 1.95103 5.57145 1.71434 5.57145C1.47764 5.57145 1.28577 5.37957 1.28577 5.14287C1.28577 3.64382 2.50099 2.42859 4.00005 2.42859C4.23675 2.42859 4.42862 2.62047 4.42862 2.85716C4.42862 3.09385 4.23675 3.28573 4.00005 3.28573ZM11.5715 2.85716C11.5715 2.62047 11.7634 2.42859 12.0001 2.42859C13.4991 2.42859 14.7143 3.64382 14.7143 5.14287C14.7143 5.37957 14.5225 5.57145 14.2858 5.57145C14.0491 5.57145 13.8572 5.37957 13.8572 5.14287C13.8572 4.1172 13.0257 3.28573 12.0001 3.28573C11.7634 3.28573 11.5715 3.09385 11.5715 2.85716ZM1.71434 10.4286C1.95103 10.4286 2.14291 10.6205 2.14291 10.8572C2.14291 11.8828 2.97438 12.7143 4.00005 12.7143C4.23675 12.7143 4.42862 12.9062 4.42862 13.1429C4.42862 13.3796 4.23675 13.5714 4.00005 13.5714C2.50099 13.5714 1.28577 12.3562 1.28577 10.8572C1.28577 10.6205 1.47764 10.4286 1.71434 10.4286ZM14.2858 10.4286C14.5225 10.4286 14.7143 10.6205 14.7143 10.8572C14.7143 12.3562 13.4991 13.5714 12.0001 13.5714C11.7634 13.5714 11.5715 13.3796 11.5715 13.1429C11.5715 12.9062 11.7634 12.7143 12.0001 12.7143C13.0257 12.7143 13.8572 11.8828 13.8572 10.8572C13.8572 10.6205 14.0491 10.4286 14.2858 10.4286Z",
    fill: "#011E29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57139 4.14282C4.80809 4.14282 4.99997 4.3347 4.99997 4.57139V11.4285C4.99997 11.6652 4.80809 11.8571 4.57139 11.8571C4.3347 11.8571 4.14282 11.6652 4.14282 11.4285V4.57139C4.14282 4.3347 4.3347 4.14282 4.57139 4.14282Z",
    fill: "#011E29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28575 4.14282C6.52244 4.14282 6.71432 4.3347 6.71432 4.57139V11.4285C6.71432 11.6652 6.52244 11.8571 6.28575 11.8571C6.04906 11.8571 5.85718 11.6652 5.85718 11.4285V4.57139C5.85718 4.3347 6.04906 4.14282 6.28575 4.14282Z",
    fill: "#011E29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99998 4.14282C8.23668 4.14282 8.42855 4.3347 8.42855 4.57139V11.4285C8.42855 11.6652 8.23668 11.8571 7.99998 11.8571C7.76329 11.8571 7.57141 11.6652 7.57141 11.4285V4.57139C7.57141 4.3347 7.76329 4.14282 7.99998 4.14282Z",
    fill: "#011E29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.71434 4.14282C9.95103 4.14282 10.1429 4.3347 10.1429 4.57139V11.4285C10.1429 11.6652 9.95103 11.8571 9.71434 11.8571C9.47764 11.8571 9.28577 11.6652 9.28577 11.4285V4.57139C9.28577 4.3347 9.47764 4.14282 9.71434 4.14282Z",
    fill: "#011E29"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4286 4.14282C11.6653 4.14282 11.8571 4.3347 11.8571 4.57139V11.4285C11.8571 11.6652 11.6653 11.8571 11.4286 11.8571C11.1919 11.8571 11 11.6652 11 11.4285V4.57139C11 4.3347 11.1919 4.14282 11.4286 4.14282Z",
    fill: "#011E29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcode);
export default __webpack_public_path__ + "static/media/barcode.9cac5d996e31ee63bae10d809374a299.svg";
export { ForwardRef as ReactComponent };